export enum Estadio {
    Localizado = "Localizado",
    Extenso = "Extenso",
    NaoSeAplica = "Não se aplica"
}